import { render } from "./Chat_Lightbox.vue?vue&type=template&id=5d7396cf"
import script from "./Chat_Lightbox.vue?vue&type=script&lang=js"
export * from "./Chat_Lightbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__